import React, { Component } from "react";
import { connect } from "react-redux";
import { Autocomplete, FormHelperText, FormLabel, TextField } from "@mui/material";
import { OutlinedInput } from "@mui/material";

import { withRouter } from "utilities/withRouter";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import commonUtilities  from "utilities/common";
import { CONFIGURATION } from "utilities/configuration";


import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import EventLogo from "components/common/eventLogo";

import "./eventType.css";

class EventType extends Component {
    constructor(props) {
        super(props);
        this.state = {
            eventDetails: this.props.eventDetails ?? ""
        };
    }

    handleGroupEventChange = (event, item) => {
        let { handleGroupEventChange } = this.props;
        handleGroupEventChange & handleGroupEventChange(item);
    };

    handleEventDetailsChange = (event) => {
        let { eventDetails } = this.state;
        eventDetails = event.target.value;
        this.setState({ eventDetails });
    };
    
    handleEventDetailsBlur = (event) => {
        let { handleEventDetailsChange } = this.props;
        handleEventDetailsChange & handleEventDetailsChange(event);
    };

    render() {

        const { error, selectedGroupType, selectedEventType } = this.props;

        let { eventDetails } = this.state;
        
        let selectPlaceHolder = this.props.localize("qma-select-label");

        const languageCode = commonUtilities.getLanguage();
        const events = commonUtilities.getEventsByLanguage(selectedGroupType?.events, languageCode);
        const selectedEventCode = selectedEventType?.code ?? "";

        let _selectedEventType = null;

        if(selectedEventCode) {
            _selectedEventType = events?.find(s => s.code === selectedEventCode);
        }
        
        if (events?.length > 0 && selectedGroupType) {

            return (

                <div className="row group-event">
                    <div className="margin-bottom margin-top-1x">
                        <EventLogo languageCode={languageCode} />
                    </div>
                    <div className="margin-bottom-1x">
                        {this.props.localize("qma-event-selection-desc")}
                    </div>
                    <Box sx={{ flexGrow: 1 }}>
                        <Grid container spacing={2}>
                            <Grid size={{ xs: 12, md: 5 }}>
                                <div className="row form-control-wrapper">
                                    <FormLabel>
                                        {this.props.localize("qma-event-type")}
                                    </FormLabel>
                                    <Autocomplete data-testid="select-group-event"
                                        popupIcon={CONFIGURATION.APPLY_FIELD_ADORNMENT ? <ExpandMoreIcon/> : null}
                                        autoHighlight
                                        value={_selectedEventType}
                                        onChange={(event, item) => this.handleGroupEventChange(event, item)}
                                        options={events}
                                        isOptionEqualToValue={(item) =>
                                            item.code === selectedEventCode
                                        }
                                        getOptionLabel={(item) =>
                                            item ? `${item.name}` : ""
                                        }
                                        renderOption={(props, item, index) => (
                                            <li {...props}>
                                                {item.name}
                                            </li>
                                        )}
                                        renderInput={(params) => (
                                            <TextField
                                                placeholder={selectPlaceHolder}
                                                className={(error?.trim().length === 0) ? "formControl" : "errorControl formControl"}
                                                {...params}
                                            />
                                        )}
                                    />
                                </div>
                                <FormHelperText error={error?.trim().length > 0}>
                                    {error?.trim().length > 0 && (
                                        error
                                    )}
                                </FormHelperText>
                            </Grid>
                        </Grid>
                    </Box>
                    <div className="row margin-top form-control-wrapper">
                        <FormLabel>
                            {this.props.localize("qma-event-details")}
                        </FormLabel>
                        <div className="row-additional-information add-info">
                            <OutlinedInput
                                multiline={true}
                                fullWidth={true}
                                rows={4}
                                inputComponent="textarea"
                                notched={true}
                                inputProps={{ maxLength: 500 }}
                                name="eventDetails"
                                value={eventDetails}
                                onChange={(event) => this.handleEventDetailsChange(event)}
                                onBlur={(event) => this.handleEventDetailsBlur(event)}
                            />                            
                        </div>
                    </div>
                </div>
            );
        }

    }
}

const mapStateToProps = (state) => ({
    groupTypes: state.groupTypes
});

export default connect(mapStateToProps)(withRouter(EventType));